/**
 * @author      joseph.murphy@zumper.com (murph)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { AnalyticsC } from '@zcode/nr-utils'
import type { Building, Listing, NormalListingData } from '@zcode/state-type'
import React from 'react'
import { FlagButtonContainer } from '../../components/flag/FlagButtonContainer'

interface DetailFlagButtonContainerProps {
  entity: Building | Listing<NormalListingData>
}

export const DetailFlagButtonContainer = ({ entity }: DetailFlagButtonContainerProps) => {
  return (
    <FlagButtonContainer
      analyticChannel={AnalyticsC.FULL_DETAIL}
      display="block"
      entity={entity}
      fontSize={{ base: 'sm', md: 'md' }}
      hasDivider={false}
      iconSize={16}
      text="Report this property"
      textAlign="left"
    />
  )
}
